import { useState, useLayoutEffect } from 'react';

export const LAPTOP = 938;
export const TABLET = 726;
export const TABLET_S = 580;
export const MOBILE_L = 423;
export const MOBILE_M = 373;
export const MOBILE_S = 318;

export const windowSizes = [
  LAPTOP,
  TABLET,
  TABLET_S,
  MOBILE_L,
  MOBILE_M,
  MOBILE_S
];

export const getWindowType = (width) => {
  const windowType = windowSizes.find((windowSize) => width >= windowSize);
  return windowType === undefined ? MOBILE_S : windowType;
};

const useWidthMeasurement = () => {
  const [size, setSize] = useState([0]);
  const windowType = getWindowType(size);

  useLayoutEffect(() => {
    const updateSize = () => {
      // Use the comments client parent container width as we might have element
      // either side of the container which affects its width.
      // For example. Content tags change the width of the comments client container
      const commentClientParentContainer = document.getElementsByClassName(
        'l-tab-content'
      )[0];
      // If for some reason the comment client parent container does not exists, default to
      // innerWidth. This will cause some scaling issue with the content laoder
      const commentClientWidth = commentClientParentContainer
        ? commentClientParentContainer.clientWidth
        : window.innerWidth;
      setSize([commentClientWidth]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);
  return windowType;
};

export default useWidthMeasurement;
